import React from 'react';
import Moment from 'react-moment';

interface FormatDateProps {
  epoch: number;
}

interface FormatDateStringProps {
  dateString: string;
}

export const FormatDateAndTime: React.FC<FormatDateProps> = ({ epoch }) => {
  const date = new Date(epoch);
  return (
    <Moment format="YYYY-MM-DD HH:mm:ss" date={date} />
  );
};

export const FormatDate: React.FC<FormatDateProps> = ({ epoch }) => {
  const date = new Date(epoch);
  return (
    <Moment format="YYYY-MM-DD" date={date} />
  );
};

export const FormatDateFromString: React.FC<FormatDateStringProps> = ({ dateString }) => {
  const date = new Date(dateString);
  return (
    <Moment format="YYYY-MM-DD" date={date} />
  );
};
